import { render, staticRenderFns } from "./MainNews.vue?vue&type=template&id=0b094dfc&scoped=true&"
import script from "./MainNews.vue?vue&type=script&lang=js&"
export * from "./MainNews.vue?vue&type=script&lang=js&"
import style0 from "./MainNews.vue?vue&type=style&index=0&id=0b094dfc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b094dfc",
  null
  
)

export default component.exports